module.exports = __webpack_public_path__ + "static/media/art63.5dad2e16.jpg";